<div class="modal is-active">
  <div class="modal-background"></div>
  <div #modalCard class="modal-card" role="dialog" aria-modal="true"
       aria-labelledby="valet-damage-check-modal-title" tabindex="-1">
    <header class="modal-card-head">
      <p id="valet-damage-check-modal-title" class="modal-card-title">{{ModalTitle}}</p>
    </header>
    <section class="modal-card-body">
      <div class="has-text-centered">
        @if (MediaId) {
          <div #imageWrapper class="damage-image-wrapper">
            <app-mediaviewer [MediaId]="MediaId" Width="100%" Height="auto"></app-mediaviewer>
            @if (markersVisible) {
              @for (c of DamageCheckCoordinates; track c.Id) {
                <div class="damage-marker"
                     [ngClass]="typeClass(c.Type)"
                     [ngStyle]="{ 'left.%': c.X * 100, 'top.%': c.Y * 100, 'width.px': dotSizePx, 'height.px': dotSizePx }">
                  <div class="damage-marker-tooltip">
                    <div class="damage-marker-tooltip-type">{{typeName(c.Type)}}</div>
                    <div class="damage-marker-tooltip-time">{{c.TimestampLocalFriendlyString || c.TimestampLocal || c.Timestamp}}</div>
                  </div>
                </div>
              }
            }
          </div>
          @if (DamageCheckCoordinates?.length) {
            @if (markersVisible) {
              <div class="damage-legend">
                <span class="legend-item"><span class="legend-dot damage-dent"></span>Dent</span>
                <span class="legend-item"><span class="legend-dot damage-scratch"></span>Scratch</span>
                <span class="legend-item"><span class="legend-dot damage-other"></span>Other</span>
              </div>
            }
          } @else {
            <p class="damage-empty-message">No damage markers have been recorded.</p>
          }
        } @else {
          <p class="damage-empty-message">No damage image is configured.</p>
        }
      </div>
    </section>
    <footer class="modal-card-foot">
      @if (DamageCheckCoordinates?.length) {
        <button class="button is-normal button-width" (click)="toggleMarkers()">
          {{ markersVisible ? 'Hide markers' : 'Show markers' }}
        </button>
      }
      <button class="button is-normal button-width" (click)="close()">Close</button>
    </footer>
  </div>
</div>
